<template>
  <div>
    <div>
      <el-form :inline="true" :model="searchForm">
        <el-form-item label="订单搜索：">
          <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
        </el-form-item>
        <el-form-item label="时间筛选：">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button>数据导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table
        border
        :data="infoList"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="orderNo"
          label="订单号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="nickName"
          label="昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderType"
          label="订单类型">
          <template slot-scope="scope">
            <span v-if="scope.row.orderType == 1">商城订单</span>
            <span v-else-if="scope.row.orderType == 2">礼品卡订单</span>
            <span v-else>体验店订单</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="thumb"
          width="450"
          label="商品信息">
          <template slot-scope="scope">
            <div class="">
              <el-image
                style="width: 32px;"
                :src="scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
                fit="contain"></el-image>
                <span>{{scope.row.cardName}}</span>
                <span>x{{scope.row.buyNumber}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderMoney"
          label="订单金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realPayMoney"
          label="支付金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="paySuccessTime"
          label="支付时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="useStatus"
          label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.useStatus == 0">待使用</span>
            <span v-if="scope.row.useStatus == 1">已使用</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detailOpenBtn(scope.row.orderId)">详情</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
    </div>
    <!-- 订单详情弹窗 -->
    <el-drawer
      size="960px"
      :visible.sync="detailShow"
      :with-header="false">
      <gift-card-order-detail :infoId="infoId"></gift-card-order-detail>
    </el-drawer>
  </div>
</template>

<script>
import { queryGiftCardOrderPageList } from '@/api/giftCard'
import GiftCardOrderDetail from './GiftCardOrderDetail.vue'
export default {
  name: 'GiftCardOrderSingle',
  components: {
    GiftCardOrderDetail
  },
  props: {
    tabCurrent: {
      type: Number,
      default: 0
    }
  },
  watch: {
    "tabCurrent"(newVal, oldVal) {
      this.currentPage = 1;
      this.getInfoList();
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        deliveryType:'',
        date:['', '']
      },
      activeName:'first',
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:'',
      // 订单详情
      detailShow:false
    }
  },
  mounted () {
    var that = this;
    that.getInfoList();
  },
  methods: {
    /* 打开详情操作 */
    detailOpenBtn(infoId){
      this.infoId = infoId;
      this.detailShow = true;
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      queryGiftCardOrderPageList({ webSearchStr: searchName, startCreateDate: startDate, endCreateDate: endDate, useStatus: tabCurrent, pageNum: page, pageSize: that.limitLength}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/components/GiftCardOrderSingle.vue